<template>
  <div class="kartu-wrapper">
    <div id="kartu" class="kartu-dimas">
      <img src="/static/images/icons/background_kartu.jpeg">
      <div class="qr-position" v-if="qrCodeValue || santri?.qr_code">
        <vue-qrcode :value="qrCodeValue || santri?.qr_code" :width="280" />
      </div>
      <img class="photo"
           :src="convertToCDNUrl(santri.image)">
      <div class="nama-depan">
        <p class="nama-lengkap">
          {{ santri.nama_lengkap }}
        </p>
        <p class="nomor">
          {{ santri.nomor }}
        </p>
      </div>
      <div class="nomor-induk">
        {{ santri.nomor }}
      </div>
      <div class="val-nomor-induk">{{ santri?.nomor_induk }}</div>
      <div class="val-nama text-truncate">{{ capitalize(santri?.nama_lengkap) }}</div>
      <div class="val-ttl text-truncate">{{ capitalize(santri?.tempat_tgl_lahir) }}</div>
      <div class="val-jk text-truncate">{{ getJenisKelamin(santri?.jenis_kelamin) }}</div>
      <div class="val-ortu text-truncate">{{ capitalize(santri?.nama_ayah) }} <br>-<br> {{ capitalize(santri?.nama_ibu) }}</div>
      <div class="val-alamat">
          {{ capitalize(santri?.alamat_lengkap) }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import Santri from "../../entity/Santri";
import {convertToCDNUrl, getJenisKelamin, getPenerimaDana} from "../../util/PluralVariabels";
import {capitalize} from "lodash";

export default defineComponent({
  name: 'KartuDimas',
  components: {VueQrcode},
  props: {
    santri: {
      type: Object,
      required: true
    },
    qrCodeValue: {
      type: String,
      default: ''
    }
  },
  methods: {convertToCDNUrl, capitalize, getPenerimaDana, getJenisKelamin},
  data() {
    return {
      imageBase64: ''
    }
  },
  async mounted() {
  },
  setup() {
    const getBase64FromUrl = async (url) => {
      const imageData = await fetch(url, {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Access-Control-Allow-Origin': '*'
        }
      });
      const blob = await imageData.blob();
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          resolve(reader.result);
        };
        reader.onerror = reject;
      });
    };
    
    return {
      getBase64FromUrl
    };
  }
});
</script>

<style lang="scss" scoped>
.kartu-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  overflow: hidden;
  padding: 10px 0;
}

/* 
 * Professional Print-Resolution Layout (1382x1040)
 * Uses CSS Scaling so it appears larger on screen, 
 * but prints at high resolution.
 */
.kartu-dimas {
  position: relative;
  text-align: center;
  color: white;
  width: 1382px;
  height: 1040px;
  min-width: 1382px;
  min-height: 1040px;
  border-radius: 36px;
  box-shadow: 0 12px 30px rgba(0,0,0,0.15);
  background: white;
  overflow: hidden;
  /* Scale down for screen display. 
   * FormViewSantri will scale it further if needed, but we provide a base responsive scale.
   */
  transform: scale(0.60);
  transform-origin: top left;
  margin-bottom: -416px;  /* Offset the height difference after scaling */
  margin-right: -553px;

  > img:first-child {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
    border-radius: 36px;
  }

  > * {
    z-index: 1;
  }

  /* FRONT CARD (Left Side: x = 0 to 691) */
  .qr-position {
    position: absolute;
    top: 195px;
    left: 77px;
    border-radius: 40px;
    padding: 16px;
    background: white;
  }

  .photo {
    position: absolute;
    border-radius: 20px;
    top: 564px;
    left: 333px;
    width: 283px;
    height: 337px;
    object-fit: cover;
    border: 6px solid white;
    background: #e0e0e0;
  }

  .nama-depan {
    position: absolute;
    top: 635px;
    left: 45px;
    width: 250px;
    text-align: center;

    .nama-lengkap {
      font-size: 34px;
      color: #363636;
      font-weight: 800;
      line-height: 1.15;
      margin-bottom: 20px;
      text-transform: uppercase;
    }

    .nomor {
      font-size: 32px;
      color: #ec7111;
      font-weight: 800;
      line-height: 1.2;
    }
  }

  /* BACK CARD (Right Side: x = 691 to 1382) */
  .val-nomor-induk, .val-nama, .val-ttl, .val-jk, .val-ortu, .val-alamat {
    position: absolute;
    left: 1045px; /* Moved further right to clear colons that are at ~1030px */
    width: 300px;
    color: #4a4a4a;
    text-align: left;
    font-weight: 800;
    font-size: 20px; 
    line-height: 1.2;
    text-transform: uppercase;
  }
  
  .val-nomor-induk {
    top: 422px;
    left: 965px; /* Right after 'Nomor Induk Santri :' */
    color: #ec7111;
    font-size: 32px;
    font-weight: 900;
  }
  
  .val-nama { top: 485px; }
  .val-ttl { top: 510px; }
  .val-jk { top: 535px; }
  .val-ortu { top: 560px; line-height: 1; }
  .val-alamat { 
    top: 585px; 
    line-height: 1.3;
    display: -webkit-box; 
    -webkit-line-clamp: 3; 
    -webkit-box-orient: vertical; 
    overflow: hidden; 
    white-space: normal;
  }
}

@media screen and (max-width: 768px) {
  .kartu-dimas {
    transform: scale(0.3);
    margin-bottom: -728px;
    margin-right: -967px;
  }
}
</style>
